import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { Button, SecondaryButtonRouterLink } from 'components/Button';
import { Icon } from 'components/Icon';
import PrintHidden from 'components/PrintHidden';
import { colors, fontWeights, gutterWidth, transition } from 'theme';
import { trackClicked } from 'utils/analytics';
import { configValue } from 'utils/config';
// eslint-disable-next-line import/no-namespace
import * as localStorage from 'utils/localStorage';

export const BANNER_NAME = 'gradFairsBannerDismissed2022';
export const bannerIsDismissed = () => {
  const isDismissed = localStorage && localStorage.getItem(BANNER_NAME);
  return isDismissed === 'true' || isDismissed === true;
};
const CloseButton = styled(Button)`
  opacity: 0.7;
  transition: all ${transition};
  &:hover {
    opacity: 1;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const GradFairsBanner = () => {
  const [dismissed, setDismissed] = useState(true);
  useEffect(() => {
    setDismissed(bannerIsDismissed());
  }, []);

  if (!configValue('idealist', 'fairsAds')) {
    return null;
  }

  const close = () => {
    localStorage.setItem(BANNER_NAME, 'true');
    setDismissed(true);
  };

  return dismissed ? null : (
    <PrintHidden>
      <Box
        data-qa-id="banner-ad"
        data-ad-type="grad-fair"
        position="relative"
        zIndex={200}
        bg={colors.waterBlue}
        color="white"
      >
        <Box
          position="absolute"
          left={0}
          top={0}
          width={1}
          height="100%"
          backgroundImage="url('/static/images/resume-database-banner.svg')"
          backgroundSize="cover"
          backgroundPosition="center"
        />
        <Box
          position="relative"
          minHeight={[80, null, null, 92]}
          width={1}
          px={gutterWidth / 2}
          py={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box pr={10} fontSize={[14, 16, null, 18]}>
            <Box
              mr="8px"
              display={['block', null, null, 'inline']}
              fontWeight={fontWeights.semiBold}
            >
              {
                /* TRANSLATORS: Grad fair promotional banner */
                getText('Considering grad school?')
              }
            </Box>
            {
              /* TRANSLATORS: Grad fair promotional banner */
              getText(`Connect with top programs at an upcoming grad fair!`)
            }
          </Box>

          <Box display="flex" alignItems="center" flex="0 0 auto">
            <SecondaryButtonRouterLink
              to="/grad-schools/attend"
              mr={16}
              square
              reverse
              onClick={() => {
                close();
                trackClicked('Grad Fairs Banner CTA', {
                  context: 'Banner',
                });
              }}
            >
              <Box minHeight={24} display="flex" alignItems="center">
                <Box display={['none', null, null, 'block']}>
                  {getText('Learn More')}
                </Box>
                <Box display={['block', null, null, 'none']}>
                  {getText('Learn More')}
                </Box>
              </Box>
            </SecondaryButtonRouterLink>

            <CloseButton
              data-qa-id="close-banner-ad-button"
              onClick={() => {
                close();
                trackClicked('Dismiss Grad Fairs CTA', {
                  context: 'Banner',
                });
              }}
            >
              <Icon initialColorName="todo-replace-me" name="close" size={16} />
            </CloseButton>
          </Box>
        </Box>
      </Box>
    </PrintHidden>
  );
};

// eslint-disable-next-line import/no-default-export
export default GradFairsBanner;
